<template>
    <el-container id="tab">
        <el-aside :width="isCollapse ? '20px' : '240px'" v-if="itemParams.billType != 'FYD'">
            <el-card v-show="!isCollapse" class="box-card" shadow="never">
                <div slot="header">
                    <span>商品类别</span>
                    <el-button style="float: right; padding: 3px 0;" icon="el-icon-d-arrow-left" type="text" @click="showCollapse"></el-button>
                </div>
                <order-cascader ref="orderCascader" :product-params="{customerID: queryitem.customerID}" :billType="'DHD'" @get-product-data="getProductData">
                </order-cascader>
            </el-card>
            <div class="isCollapse" v-show="isCollapse" @click="showCollapse">
                <span style="text-align: center;">商品</span>
                <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
                <span style="text-align: center;">类别</span>
            </div>
        </el-aside>
        <el-main>
            <template v-if="itemParams.billType != 'FYD'">
                <el-card shadow="never">
                    <el-form :inline="true" :model="queryForm" class="query_form" ref="queryFormRef" size="small">
                        <div class="card-top">
                            <el-dropdown size="small" @command="handleCommand">
                                <el-button type="primary" size="small">
                                    选中单据<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :command="item.value" v-for="item in commandList" :key="item.value">{{item.text}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <div class="card-type">当前选中：{{commandList.filter(item => item.value == itemParams.billType)[0].text}}</div>
                            <el-form-item label="单据日期" prop="billDate.selected">
                                <el-date-picker v-model="queryForm.billDate.selected" type="date" value-format="yyyy-MM-dd" placeholder="请选择单据日期" @change="getNext('',  itemParams.billType == 'DBD' ? 'salesman' : 'customer')">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="card-bottom">
                            <el-form-item :label="itemParams.billType == 'CGD' ? '供应商' : '客户'" prop="customer.selected" v-if="itemParams.billType != 'DBD'">
                                <select-multiple class="query_form_item" ref="customer" :change="() => { getNext('', 'salesman') }" :select-data="queryForm.customer" :isClear="false"></select-multiple>
                            </el-form-item>
                            <el-form-item label="业务员" prop="salesman.selected">
                                <select-multiple class="query_form_item" ref="salesman" :change="() => { getNext('', 'warehouse') }" :select-data="queryForm.salesman" :isClear="false"></select-multiple>
                            </el-form-item>
                            <el-form-item :label="itemParams.billType == 'CGD' ? '入库库房' : '出库库房'" prop="warehouse.selected">
                                <select-multiple class="query_form_item" ref="warehouse" :change="() => { getNext('', itemParams.billType == 'DBD' ? 'inWarehouse' : '') }" :select-data="queryForm.warehouse" :isClear="false"></select-multiple>
                            </el-form-item>
                            <el-form-item label="入库库房" prop="inWarehouse.selected" v-if="itemParams.billType == 'DBD'">
                                <select-multiple class="query_form_item" ref="inWarehouse" :change="() => { getNext('', '') }" :select-data="queryForm.inWarehouse" :isClear="false"></select-multiple>
                            </el-form-item>
                        </div>
                    </el-form>
                </el-card>
                <orderEntering ref="order" :from="{...itemParams, ...queryitem}" :power="power"></orderEntering>
            </template>
            <template v-else>
                <el-card shadow="never" class="fyd">
                    <el-form :inline="true" :model="queryForm" class="query_form" size="small" ref="queryFormRef">
                        <div class="card-top fyd-top">
                            <el-dropdown size="small" @command="handleCommand">
                                <el-button type="primary" size="small">
                                    选中单据<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :command="item.value" v-for="item in commandList" :key="item.value">{{item.text}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <div class="card-type">当前选中：{{commandList.filter(item => item.value == itemParams.billType)[0].text}}</div>
                            <el-form-item label="单据日期" prop="billDate.selected">
                                <el-date-picker value-format="yyyy-MM-dd" v-model="queryForm.billDate.selected" type="date" placeholder="请选择单据日期" @change="getNext('', 'customer')">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="fyd-bottom">
                            <el-form-item label="客户" prop="customer.selected">
                                <select-multiple class="query_form_item" ref="customer" :change="() => { getNext('', 'handle') }" :select-data="queryForm.customer" :isClear="false"></select-multiple>
                            </el-form-item>
                            <el-form-item label="经手人" prop="handle.selected">
                                <select-multiple class="query_form_item" ref="handle" :change="() => { getNext('', 'type') }" :select-data="queryForm.handle" :isClear="false"></select-multiple>
                            </el-form-item>
                        </div>
                        <div class="fyd-bottom">
                            <el-form-item label="费用类型" prop="type.selected">
                                <select-multiple class="query_form_item" ref="type" :change="() => { getNext('', 'payAmt') }" :select-data="queryForm.type" :isClear="false"></select-multiple>
                            </el-form-item>
                            <el-form-item label="金额" prop="payAmt.selected">
                                <el-input-number v-model.number="queryForm.payAmt.selected" ref="payAmt" @focus="focusAfterSelect" :precision="2" :min="0" :controls="false" style="width: 100%;"></el-input-number>
                            </el-form-item>
                        </div>
                        <div class="fyd-bottom" style="align-items: flex-start;">
                            <el-form-item label="日期" prop="range.selected">
                                <date-picker style="width: 240px;" v-model="queryForm.range.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :value-format="'yyyy-MM-dd'" :picker-options="pickerOptions">
                                </date-picker>
                            </el-form-item>
                            <el-form-item label="备注" prop="remark.selected">
                                <el-input v-model="queryForm.remark.selected" ref="remark" type="textarea" :autosize="{ minRows: 2 }" clearable placeholder="请输入备注"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                    <div class="fyd-btn">
                        <el-button type="primary" size="medium" @click="submitFYD(true)">提交</el-button>
                        <el-button type="primary" size="medium" @click="submitFYD(true, 'A')">提交并打印</el-button>
                    </div>
                </el-card>
            </template>
        </el-main>
    </el-container>
</template>
<script>
import datePicker from '@/components/common/datePicker.vue'
import orderCascader from '@/components/saleManage/salOrderMeet/orderCascader.vue'
import orderEntering from '@/components/supplement/orderEntering.vue'
import { pickerOptions, toRawType, getResultArray, toFixedRe, getAddDate, getNowFormatDate } from '@/assets/js/common.js'
export default {
    name: "supplementIndex",
    components: {
        orderCascader,
        datePicker,
        orderEntering
    },
    data() {
        let beginDate = getAddDate(-3)
        let endDate = getNowFormatDate()
        return {
            isCollapse: false,
            queryForm: {
                billDate: { submitName: 'billDate', selected: '' },
                customer: { submitName: 'customer', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                salesman: { submitName: 'salesman', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择业务员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                inWarehouse: { submitName: 'inWarehouse', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择入库仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                warehouse: { submitName: 'warehouse', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                handle: { submitName: 'handle', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择经手人', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                type: { submitName: 'type', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择费用类型', request: { url: '/Account/dataSearchVue/getFeeTypeList.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                payAmt: { submitName: 'payAmt', selected: '' },
                range: { submitName: 'range', selected: [beginDate, endDate] },
                remark: { submitName: 'remark', selected: '' },
            },
            pickerOptions: pickerOptions,
            tableData: [],
            selection: {
                length: 0,
                amt: 0,
                adjustAmt: 0,
                prePayAmt: 0
            },
            itemParams: {
                firstValue: '',
                secondValue: '',
                billType: 'XSD'
            },
            power: {},
            commandList: [{
                value: 'XSD',
                text: '销售单'
            }, {
                value: 'CGD',
                text: '采购单'
            }, {
                value: 'DBD',
                text: '调拨单'
            }, {
                value: 'FYD',
                text: '费用单'
            }],
        }
    },
    computed: {
        queryitem() {
            let tempItem = {}
            Object.values(this.queryForm).forEach(item => {
                if (item.submitName == 'range') {
                    if (this.itemParams.billType == 'FYD') {
                        tempItem['startDate'] = item.selected[0]
                        tempItem['endDate'] = item.selected[1]
                    }
                } else if (toRawType(item.selected) == 'Object') {
                    if (['inWarehouse', 'customer', 'warehouse', 'salesman', 'handle', 'type'].includes(item.submitName)) {
                        if (item.selected.value) {
                            tempItem[item.submitName + 'ID'] = item.selected.value || ''
                            tempItem[item.submitName + 'Name'] = item.selected.text || ''
                        }
                        return false
                    }
                    tempItem[item.submitName] = item.selected.value || ''
                } else {
                    if (item.selected) tempItem[item.submitName] = item.selected
                }
            })
            return tempItem
        },
    },
    created() {
        this.power = top.indexVm.$store.state.power
        console.log(top.indexVm.$store.state)
    },
    mounted() {
        this.$nextTick(() => {
            $(this.$refs.customer.$el).find('input').click(this.selectClick)
            $(this.$refs.warehouse.$el).find('input').click(this.selectClick)
        })
    },
    watch: {
    },
    directives: {
        focus: {
            inserted: function(el) {
                el.querySelector('input').onfocus = function(e) {
                    e.currentTarget.select()
                }
                el.querySelector('input').focus()
            }
        }
    },
    methods: {
        getProductData(e) {
            // this.itemParams = e
            console.log(e)
            // console.log(this.$refs.queryFormRef)
            if(this.$refs.order) {
                console.log(this.$refs.order)
                let item = this.$refs.order.itemName.request.params
                this.$refs.order.itemName.request.params = { ...item, ...e }
            }
        },
        showCollapse() {
            this.isCollapse = !this.isCollapse
            // this.$refs.queryFormRef.getHeight()
        },
        async getNext(e, tag) {
            console.log(tag)
            if (tag) {
                this.$nextTick(() => {
                    this.$refs[tag].focus()
                })
            } else {
                if (this.queryitem.inWarehouseID == this.queryitem.warehouseID && this.itemParams.billType == 'DBD') {
                    this.queryForm.inWarehouse.selected = {}
                    return this.$message({
                        showClose: true,
                        message: '入库库房、出库库房不能一致',
                        type: 'warning'
                    })
                }
            }
        },
        async submitFYD(isDraft, command) {
            console.log(this.queryitem)
            if (!this.queryitem.billDate || this.queryitem.billDate == '') return this.$message({
                showClose: true,
                message: '请先选择单据日期',
                type: 'warning'
            })
            if (!this.queryitem.customerID || this.queryitem.customerID == '') return this.$message({
                showClose: true,
                message: '请先选择客户',
                type: 'warning'
            })
            if (!this.queryitem.handleID || this.queryitem.handleID == '') return this.$message({
                showClose: true,
                message: '请先选择经手人',
                type: 'warning'
            })
            if (!this.queryitem.typeID || this.queryitem.typeID == '') return this.$message({
                showClose: true,
                message: '请先选择费用类型',
                type: 'warning'
            })
            if (!this.queryitem.payAmt) return this.$message({
                showClose: true,
                message: '请先输入金额',
                type: 'warning'
            })
            let obj = {
                headInfo: JSON.stringify({ ...this.queryitem,
                    ...{ payType: 'A' }
                }),
                billType: this.itemParams.billType,
                billDate: this.queryitem.billDate,
            }
            console.log(obj)
            let url = '/Account/supplementOrderVue/addSupplementOrder.html'
            let currTab = '',
                title = ''
            if (top.$('#tabspanel .tabs-selected').text()) {
                currTab = top.$('#tabspanel').tabs('getSelected') || ''
                title = top.$('#tabspanel .tabs-selected').text() || ''
            } else {
                title = top.getTabName()
                currTab = top.getTabName()
            }
            const loading = this.$loading({
                lock: true,
                text: '记账中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            const { data: res } = await this.$http.post(url, this.Qs.stringify(obj))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            if (command == 'A') {
                let billNo = JSON.parse(JSON.parse(res.result).data).billNo
                console.log(billNo)
                window.open(`/Account/feebill/customerFee/Print.html?billNo=${ billNo }&isLodopPrint=N`, '_blank', "width=1011,height=680,left=300,top=150,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,location=no")
            }
            this.$message.success(res.message)
            setTimeout(() => {
                top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/supplementIndex`, currTab)
            }, 500)
        },
        async handleCommand(command) {
            console.log(command)
            if (this.$refs.order && this.$refs.order.sum.total > 0) {
                const confirmResult = await this.$confirm('您已录入商品，此操作将可能导致商品价格错误, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).catch(err => err)
                if (confirmResult !== 'confirm') {
                    return
                }
            }
            this.itemParams.billType = command
            this.$refs['queryFormRef'].resetFields()
            this.$nextTick(() => {
                if (command == 'DBD') {
                    $(this.$refs.inWarehouse.$el).find('input').click(this.selectClick)
                }
                console.log(this.$refs.order)
                if (this.$refs.order) {
                    this.$refs.order.resetTable()
                    this.$refs.order.itemName.request.params.billType = this.itemParams.billType
                    this.$refs.order.isLargessFormat.request.params.billType = this.itemParams.billType
                }
                if (command == 'CGD') {
                    this.queryForm.customer.placeholder = '请选择供应商'
                    this.queryForm.customer.request.params.customerType = 'V'
                } else {
                    this.queryForm.customer.placeholder = '请选择客户'
                    this.queryForm.customer.request.params.customerType = 'S'
                }
                for (let j in this.queryForm) {
                    if (this.queryForm[j].request) {
                        this.queryForm[j].request.params.page = 1
                        if (this.$refs[j]) this.$refs[j].getList()
                    }
                }
            })
        },
        selectClick() {
            this.$nextTick(async () => {
                if (this.$refs.order.sum.total > 0) {
                    const confirmResult = await this.$confirm('您已录入商品，此操作将删除所以表格数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).catch(err => err)
                    if (confirmResult !== 'confirm') {
                        this.$refs['customer'].$children[0].blur()
                        this.$refs['warehouse'].$children[0].blur()
                        if (this.$refs['inWarehouse']) this.$refs['inWarehouse'].$children[0].blur()
                        return
                    }
                }
            })
        },
        focusAfterSelect(e) {
            e.currentTarget.select()
        },
    }
};
</script>
<style scoped lang="less">
#tab {

    // height: calc(100vh - 20px);
    .el-aside {
        .box-card {
            height: calc(100% - 2px);

            ::v-deep .el-card__header {
                padding: 8px 20px;
                height: 33px;
            }

            ::v-deep .el-card__body {
                padding: 0;
                height: calc(100% - 33px);

                .el-cascader-panel.is-bordered {
                    border: none;
                    width: 100%;
                    height: 100%;
                    display: flex;

                    .el-cascader-menu {
                        flex: 1;
                        min-width: 0;
                    }

                    .el-cascader-menu__wrap {
                        height: 100%;
                        overflow-x: hidden;
                    }

                    .el-cascader-node__label {
                        width: 100%;
                        padding: 0;
                    }

                    .el-cascader-node {
                        padding: 0 20px 0 6px;
                        flex-direction: column;
                    }

                    .badge {
                        right: 0;
                        position: absolute;
                        transform: scale(0.8);
                    }

                    .cascader_text {
                        width: 100%;
                        display: inline-block;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    .el-cascader-panel .el-icon-check:before {
                        content: '';
                    }

                    .el-cascader-node__postfix,
                    .el-cascader-node__prefix {
                        display: none;
                    }
                }
            }
        }

        .isCollapse {
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
            border: 1px #DCDFE6 solid;
            cursor: pointer;
            background-color: rgba(83, 168, 255, 0.1);
            color: #409EFF;
        }
    }

    .el-main {
        margin-left: 6px;
        padding: 0 12px;
        border: 1px solid #DCDFE6;

        ::v-deep .el-card__body {
            padding: 8px 12px;
        }

        .fyd {
            ::v-deep .el-card__body {
                padding: 40px;
            }

            .fyd-btn {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
            }
        }

        .card-top {
            display: flex;
            flex-direction: row;
            align-items: center;

            &.fyd-top {
                justify-content: center;
            }

            .card-type {
                font-size: 14px;
                color: #409EFF;
                margin-left: 12px;
                font-weight: bolder;
            }

            .el-form-item {
                margin-left: 12px;
                margin-bottom: 0;
                margin-right: 0;
            }
        }

        .query_form {
            position: relative;
            display: flex;
            flex-direction: column;

            .card-bottom {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-top: 18px;

                .el-form-item {
                    margin-bottom: 0;
                    position: relative;
                }

                ::v-deep .el-form-item__label {
                    position: absolute;
                    z-index: 2;
                    top: -12px;
                    margin-left: 10px;
                    padding: 0 6px;
                    background-color: #fff;
                    line-height: normal;
                    font-family: "Helvetica Neue";
                    font-size: 12px;
                    color: #909399;
                }
            }

            .query_form_item {
                position: relative;
                flex: 1;
                margin-bottom: 0;
            }

            .select_multiple {
                ::v-deep .el-select__tags {
                    max-height: 80px;
                    overflow-y: auto;
                    overflow-x: hidden;
                }
            }

            .fyd-bottom {
                margin-top: 18px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                flex-wrap: wrap;

                ::v-deep .el-form-item__label {
                    width: 70px;
                }

                ::v-deep .el-input,
                ::v-deep .el-textarea {
                    width: 240px;
                }

                ::v-deep .el-input-number {
                    .el-input__inner {
                        text-align: left;
                    }
                }
            }
        }

        .table {
            height: calc(100% - 105px - 45px);

            &.show {
                height: calc(100% - 105px - 45px - 21px - 12px);
            }

            ::v-deep .el-table {

                td,
                th {
                    padding: 0;

                    .cell {
                        font-size: 14px;
                        padding: 0;
                    }
                }

                td {
                    .cell {
                        span {
                            font-size: 14px;
                        }
                    }
                }

                .el-input-number,
                .el-autocomplete {
                    .el-input__inner {
                        padding: 0;
                        text-align: left;
                    }
                }
            }
        }

        .el-checkbox-group {
            margin-top: 12px;
        }

        .main_footer {
            height: 45px;
            display: flex;
            align-items: center;

            .text {
                color: #F56C6C;
                padding: 0 4px;
            }

            span {
                width: 50%;
            }

            div {
                transform: translate(-50%, 0);
            }
        }
    }
}
</style>